import { render } from "./HomeBestProducts.vue?vue&type=template&id=7c66af9e"
import script from "./HomeBestProducts.vue?vue&type=script&lang=js"
export * from "./HomeBestProducts.vue?vue&type=script&lang=js"

import "./HomeBestProducts.vue?vue&type=style&index=0&id=7c66af9e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__